import { AnimatedNumber } from '@/components/Text';
import { APP_SCORING_FORMAT } from '@/constants';
import { formatScore } from '@/domains';
import { FormattedScore } from './ScorecardFormattedScore';
import React from 'react';

export interface AnimatedScoreProps {
  isPrinting?: boolean;
  maxScore: number;
  score?: number;
}

export const AnimatedScore: React.FC<AnimatedScoreProps> = ({
  isPrinting = false,
  maxScore,
  score,
}) => {
  if (isPrinting) {
    return <FormattedScore maxScore={maxScore} score={score} />;
  }

  if (APP_SCORING_FORMAT === 'percentage') {
    return (
      <div className="flex items-center justify-start">
        <AnimatedNumber
          delay={200}
          duration={300}
          formatValue={(v) => formatScore(v, undefined, 'percentage')}
          value={score ?? 0}
        />
      </div>
    );
  }

  if (APP_SCORING_FORMAT === 'numerical grade') {
    return (
      <div className="flex items-center justify-start">
        <AnimatedNumber delay={200} duration={300} formatValue={(v) => v} value={score ?? 0} />
        <span>{`/${maxScore}`}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-start">
      <AnimatedNumber
        delay={200}
        duration={150}
        formatValue={(v) => formatScore(v, maxScore)}
        value={score ?? 0}
      />
    </div>
  );
};

AnimatedScore.displayName = 'AnimatedScore';

export default AnimatedScore;
